import { useEffect, useRef } from 'react';

import { useVirtualToggleManager } from 'hooks/useVirtualToggleManager';

import type { ExtendedIndexUIState } from '../types';

export const InitialVirtualToggleHandler = ({
  initialIndexUIState,
}: {
  initialIndexUIState: ExtendedIndexUIState;
}) => {
  const defaultStateProcessed = useRef(initialIndexUIState === undefined);
  const setVirtualToggle = useVirtualToggleManager();

  useEffect(() => {
    if (!defaultStateProcessed.current) {
      defaultStateProcessed.current = true;
      setVirtualToggle({ ...initialIndexUIState.virtualToggle }, false);
    }
  }, [setVirtualToggle, initialIndexUIState]);

  return null;
};
